import './App.css';
import React from "react";
import '@ant-design/v5-patch-for-react-19';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./components/PrivateRoute";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import MatchDetails from "./pages/MatchDetails";
import SettingsPage from "./pages/SettingsPage";
import PasswordResetConfirmPage from "./pages/PasswordResetConfirmPage";
import EqualOffensePage from "./pages/EqualOffensePage";
import PracticePage from "./pages/PracticePage";
import consoleLogger from "./utils/consoleLogger";

// Initialisiere den globalen Console Logger sofort beim App-Start
consoleLogger.init();

// QueryClient erstellen
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 Minuten
      retry: 1,
      refetchOnWindowFocus: false, // Erstmal deaktiviert für bessere Entwicklung
    },
  },
});

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <SettingsPage />
              </PrivateRoute>
            }
          />
          <Route path="/password-reset/confirm" element={<PasswordResetConfirmPage />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/match/:id"
            element={
              <PrivateRoute>
                <MatchDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/equal-offense"
            element={
              <PrivateRoute>
                <EqualOffensePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/practice"
            element={
              <PrivateRoute>
                <PracticePage />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};

export default App;
